/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import SettlementCosts from "./SettlementCosts";
import { AbstractCase } from "../../../types/Entities/AbstractCase";
import ProductBox from "@/src/components/ProductBox/ProductBox";

type CostBoxProps = {
  settlement: AbstractCase;
};

const CostBox = ({ settlement }: CostBoxProps) => {
  if (settlement.isInitialProxy || (settlement.noWinNoFee && !settlement.nWnFAmount)) {
    return null;
  }

  return (
    <ProductBox headline={"Abfindung & Kosten"}>
      {settlement && <SettlementCosts settlement={settlement} />}
    </ProductBox>
  );
};

export default CostBox;
